import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

// Access to the embedded (iframe) shopper-admin wrapper: the L1 nav entry and
// both DomainRoutes. The domain ships dark — no role holds this permission
// until it is provisioned in IPP RBAC and mapped to the appropriate roles.
export const ShoppersAdminViewAccessControl: DomainAccessControlConfig = [
  { permissions: [Permission.ShopperAdminEmbeddedAppView] },
]
